/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  EvidenceListResponseDto,
  ListEvidenceQueryControllerListParams,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Aggregates completed compliance task instances and checklists. The hub is category-driven: without `categoryId` the response is an empty page. Compliance rows are included only when the organisation's plan unlocks COMPLIANCE_TASKS (platform admins bypass), so `meta.total` is plan-dependent. Each source contributes at most its 1000 newest completions *for the requested category*; beyond that the oldest records (and `meta.total`) are truncated.
 * @summary List completed evidence records for a nursery across all sources (paginated)
 */
export const listEvidenceQueryControllerList = (
  nurseryId: string,
  params?: ListEvidenceQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<EvidenceListResponseDto>({
    url: `/v1/nurseries/${nurseryId}/evidence`,
    method: "GET",
    params,
    signal,
  });
};

export const getListEvidenceQueryControllerListQueryKey = (
  nurseryId: string,
  params?: ListEvidenceQueryControllerListParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/evidence`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListEvidenceQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listEvidenceQueryControllerList>>,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListEvidenceQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEvidenceQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListEvidenceQueryControllerListQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEvidenceQueryControllerList>>
  > = ({ signal }) =>
    listEvidenceQueryControllerList(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listEvidenceQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEvidenceQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEvidenceQueryControllerList>>
>;
export type ListEvidenceQueryControllerListQueryError = unknown;

export function useListEvidenceQueryControllerList<
  TData = Awaited<ReturnType<typeof listEvidenceQueryControllerList>>,
  TError = unknown,
>(
  nurseryId: string,
  params: undefined | ListEvidenceQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEvidenceQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvidenceQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listEvidenceQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListEvidenceQueryControllerList<
  TData = Awaited<ReturnType<typeof listEvidenceQueryControllerList>>,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListEvidenceQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEvidenceQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvidenceQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listEvidenceQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListEvidenceQueryControllerList<
  TData = Awaited<ReturnType<typeof listEvidenceQueryControllerList>>,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListEvidenceQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEvidenceQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List completed evidence records for a nursery across all sources (paginated)
 */

export function useListEvidenceQueryControllerList<
  TData = Awaited<ReturnType<typeof listEvidenceQueryControllerList>>,
  TError = unknown,
>(
  nurseryId: string,
  params?: ListEvidenceQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEvidenceQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListEvidenceQueryControllerListQueryOptions(
    nurseryId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
